<template>
	<vs-popup :fullscreen="fullscreen" :title="title" :active.sync="activeValue" :button-close-hidden="hiddenBoolean">
		<slot></slot>
	</vs-popup>
</template>
<script>
export default {
	name: "PopupCustomize",
	data() {
		return {
			windowWidth: screen.width,
		};
	},
	props: {
		fullscreen: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: null,
		},
		active: {
			type: Boolean,
			default: false,
		},
		hiddenBoolean: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		activeValue: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("showPopup", value);
			},
		},
	},
	mounted() {
		window.addEventListener("resize", () => {
			this.windowHeight = window.innerHeight;
		});
		const popup = document.querySelector(".vs-popup");
		if (popup !== null) popup.setAttribute("style", "width: 73%; height:1200px");
	},
};
</script>
